import Service, { inject as service } from '@ember/service';

export default class CompanyTeamMembershipCommands extends Service {
  @service api;

  /**
   *
   * @param companyTeamId
   * @param userId
   * @returns {*}
   */
  destroyCompanyTeamMembership(companyTeamId, userId) {
    return this.api.delete(`company-teams/${companyTeamId}/removeMember/${userId}`);
  }

  /**
   *
   * @param companyTeamId
   * @param userId
   * @returns {*}
   */
  storeCompanyTeamMembership(companyTeamId, userId) {
    return this.api.post(`company-teams/${companyTeamId}/addMember/${userId}`);
  }

  storeUserAsMemberOfAllTeams(companyId, userId) {
    return this.api.post(`companies/${companyId}/addMemberToAllTeams/${userId}`);
  }
}
